import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Slide, Snackbar } from '@mui/material'

const SlideTransition = (props) => <Slide {...props} direction="left" />

export const TOAST_SEVERITY = {
  SUCCESS: 'success',
  DANGER: 'error'
}

export const Toast = ({ open, message, severity, onClose, duration }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={SlideTransition}>
      <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

Toast.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(Object.values(TOAST_SEVERITY)).isRequired,
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number
}

Toast.defaultProps = {
  duration: 4000
}
